import { Link } from "react-router";
import { TENDERS_ENABLED } from "~/lib/features";

const footerSections = [
	{
		title: "Produkt",
		links: [
			{ label: "Služby", href: "/#funkce" },
			{ label: "Firemní události", href: "/firemni-udalosti" },
			{ label: "Ceník", href: "/cenik" },
			{ label: "API dokumentace", href: "https://api.firmindex.cz/reference", external: true },
		],
	},
	{
		title: "Procházet",
		links: [
			{ label: "Vyhledávání firem", href: "/search" },
			...(TENDERS_ENABLED ? [{ label: "Veřejné zakázky", href: "/verejne-zakazky" }] : []),
			{ label: "Odvětví (NACE)", href: "/directory/odvetvi" },
			{ label: "Kraje", href: "/directory/kraj" },
		],
	},
	{
		title: "Společnost",
		links: [
			{ label: "O nás", href: "/o-nas" },
			{ label: "Kontakt", href: "/kontakt" },
		],
	},
	{
		title: "Právní",
		links: [
			{ label: "Obchodní podmínky", href: "/podminky" },
			{ label: "Ochrana soukromí", href: "/ochrana-soukromi" },
			{ label: "Zásady cookies", href: "/cookie-policy" },
		],
	},
];

export function Footer() {
	return (
		<footer className="bg-gray-900 text-gray-300">
			<div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
				<div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
					{footerSections.map((section) => (
						<div key={section.title}>
							<h3 className="text-sm font-semibold text-white">{section.title}</h3>
							<ul className="mt-4 space-y-3">
								{section.links.map((link) => (
									<li key={link.label}>
										{"external" in link && link.external ? (
											<a
												href={link.href}
												target="_blank"
												rel="noopener noreferrer"
												className="text-sm hover:text-white transition-colors"
											>
												{link.label}
											</a>
										) : (
											<Link to={link.href} className="text-sm hover:text-white transition-colors">
												{link.label}
											</Link>
										)}
									</li>
								))}
							</ul>
						</div>
					))}

					{/* Contact column */}
					<div>
						<h3 className="text-sm font-semibold text-white">Kontakt</h3>
						<ul className="mt-4 space-y-3 text-sm">
							<li>Recadev s.r.o.</li>
							<li>info@firmindex.cz</li>
							<li>IČO: 07654090</li>
							<li>Ostrava, Česká republika</li>
						</ul>
					</div>
				</div>

				<div className="mt-12 border-t border-gray-700 pt-8 text-center text-sm text-gray-400">
					&copy; {new Date().getFullYear()} Recadev s.r.o. Všechna práva vyhrazena.
				</div>
			</div>
		</footer>
	);
}
